Sports.$inject = ['_', 'CONST', 'Time'];

/* @ngInject */
function Sports(_, CONST, Time) {
    var sports = [];

    activate();

    ////////////////

    function activate() {
        sports = _.mapValues(CONST.sports, create);
    }

    function create(payload) {
        return new Sport(payload);
    }

    function get(id) {
        return _.find(sports, {
            id: id
        });
    }

    function collect(filter, withDurations) {
        var chain = _(sports).pick(filter);

        if (withDurations) {
            chain.each(function (sport) {
                sport.formattedDurations = sport.getFormattedDurations();
            });
        }

        return chain.values().value();
    }

    function formatDurations(array) {
        return _(array)
            .map(function (duration) {
                return {
                    name: Time.durationToString(duration),
                    value: duration
                };
            })
            //.keyBy('id')
            .value();
    }

    function Sport(data) {
        this.id = data.id;
        this.name = data.name;
        this.data = data;
    }

    Sport.prototype.getDurations = function () {
        return this.data.durations || [];
    };

    Sport.prototype.getFormattedDurations = function () {
        return formatDurations(this.getDurations());
    };

    return {
        get: get,
        collect: collect,
        formatDurations: formatDurations
    };
}

export default Sports;